export default "__VITE_ASSET__fd555ab1__"